import * as React from "react"
import { MainNav } from "@/components/MainNav"
import { cn } from "@/lib/utils"

// `wide` lets pages break out of the default 4xl content cap:
//   - false    → max-w-4xl (default reading width)
//   - "medium" → max-w-5xl (mid-size detail pages — brief detail, etc.)
//   - true     → max-w-7xl (kanban / calendar)
//   - "wider"  → ~max-w-8xl (Pipeline kanban — extra column breathing room)
//
// `topNav` renders edge-to-edge above the padded content container — meant
// for page-context sub-navigation that should anchor to the viewport top
// (the slot itself is positioned by the caller; pass `sticky top-0` to pin).
export function AppShell({
  children,
  topNav,
  wide = false,
}: {
  children: React.ReactNode
  topNav?: React.ReactNode
  wide?: boolean | "medium" | "wider"
}) {
  const maxWidth =
    wide === "wider"
      ? "max-w-[96rem]"
      : wide === "medium"
        ? "max-w-5xl"
        : wide
          ? "max-w-7xl"
          : "max-w-4xl"

  return (
    <div className="flex min-h-screen bg-page text-ink-body">
      <MainNav />
      <main className="min-w-0 flex-1">
        <div className={cn("mx-auto px-6 sm:px-10", maxWidth)}>
          {topNav}
          <div className="py-8">{children}</div>
        </div>
      </main>
    </div>
  )
}
